module.exports = __webpack_public_path__ + "images/thumbs-up09623e72173eaf0b243e4504cb747585.svg";